import {useState, useEffect} from 'react';

let globalState = {};
let listeners = [];
let actions = {};

export const useStore = () => {
    const setState = useState(globalState)[1];

    const dispatch = (actionIdentifier, payload) => {
        const newState = actions[actionIdentifier](globalState, payload);
        globalState = {...globalState, ...newState};

        for (const listener of listeners) {
            listener(globalState);
        }
    };

    useEffect(() => {
        listeners.push(setState);

        return () => {
            listeners = listeners.filter(li => li !== setState);
        };
    }, [setState]);

    return [globalState, dispatch];
}


// Define specific actions here
const userActions = {
    UPDATE_RID: (state, payload) => {
        // console.log('UPDATE_RID action called with year:', payload.year);
        let year = Number(payload.year);
        let newRid;
        switch (year) {
            case 2024:
                newRid = 56;
                break;
            case 2025:
                newRid = 163;
                break;
            default:
                newRid = state.ticketTypeData['studio-tour'].rid; // Ensuring fallback
                break;
        }
        // console.log('Updated RID:', newRid);
        return {
            ...state, ticketTypeData: {
                ...state.ticketTypeData, 'studio-tour': {...state.ticketTypeData['studio-tour'], rid: newRid}
            }
        };
    }
};

export const initStore = (userActions, initialState) => {
    if (initialState) {
        globalState = {...globalState, ...initialState};
    }
    actions = {...actions, ...userActions};
};

// Assume some default or initial state if needed based off the current year
let initial_rid;
const start_year = new Date().getFullYear();

switch (start_year) {
    case 2024:
        initial_rid = 56;
        break;
    case 2025:
        initial_rid = 163;
        break;
    default:
        initial_rid = 163; // Ensuring fallback
        break;
}

const initialState = {
    ticketTypeData: {
        'studio-tour': {
            rid: initial_rid,  // Default starting RID based on current year.
        },
    }
};

// Initialize the store with the defined actions and initial state (should be called once, typically in a root or setup file)
initStore(userActions, initialState);